import { apiConstants } from "../_constants";
import { authHeader, handleResponse } from "../_helpers";
export const topicService = {
    topicList,
    bookmarkAdd,
    getbookmarks,
    deleteBookmark
};

function topicList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/gettopicList", requestOptions).then(
        handleResponse
    );
}

function bookmarkAdd(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/addbookmark', requestOptions).then(handleResponse);
}

function getbookmarks(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/getbookmark', requestOptions).then(handleResponse);
}
function deleteBookmark(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + '/deletebookmark', requestOptions).then(handleResponse);
}

